import { siteInfo } from '@/mocks/homeData';

export default function Hero() {
  const handleClick = (e: React.MouseEvent<HTMLAnchorElement>, href: string) => {
    e.preventDefault();
    const el = document.querySelector(href);
    if (el) el.scrollIntoView({ behavior: 'smooth' });
  };

  return (
    <section
      id="hero"
      className="relative w-full min-h-screen flex items-center pt-[72px] overflow-hidden"
    >
      <div className="absolute inset-0 bg-gradient-to-br from-primary-50/60 via-background-50 to-accent-50/40"></div>

      <div className="relative z-10 w-full px-4 md:px-6 py-10 md:py-20">
        <div className="max-w-7xl mx-auto flex flex-col lg:flex-row items-center gap-10 lg:gap-16">
          <div className="w-full lg:w-1/2 flex flex-col items-start gap-6">
            <span className="inline-flex items-center gap-1.5 px-3 py-1.5 rounded-full bg-primary-100/80 text-primary-700 text-xs font-medium whitespace-nowrap">
              <i className="ri-sparkling-line text-sm"></i>
              {siteInfo.tagline}
            </span>

            <h1 className="text-2xl md:text-4xl lg:text-5xl font-heading text-foreground-950 leading-tight">
              {siteInfo.h1}
            </h1>

            <p className="text-lg md:text-xl text-primary-600 font-heading">
              {siteInfo.slogan}
            </p>

            <div className="space-y-3">
              <p className="text-sm md:text-base text-foreground-700 leading-relaxed">
                {siteInfo.intro1}
              </p>
              <p className="text-sm md:text-base text-foreground-700 leading-relaxed">
                {siteInfo.intro2}
              </p>
            </div>

            <div className="flex flex-wrap items-center gap-6 md:gap-8">
              {siteInfo.stats.map((stat) => (
                <div key={stat.label} className="flex flex-col items-start">
                  <span className="text-lg md:text-xl font-heading text-primary-500">
                    {stat.value}
                  </span>
                  <span className="text-xs text-foreground-500">{stat.label}</span>
                </div>
              ))}
            </div>

            <div className="flex flex-col sm:flex-row items-start sm:items-center gap-3">
              <a
                href={siteInfo.ctaPrimary.href}
                onClick={(e) => handleClick(e, siteInfo.ctaPrimary.href)}
                className="inline-flex items-center gap-2 px-6 py-3 bg-primary-500 text-background-50 rounded-full text-sm font-medium hover:bg-primary-600 transition-colors duration-200 whitespace-nowrap cursor-pointer"
              >
                <i className="ri-book-open-line"></i>
                {siteInfo.ctaPrimary.label}
              </a>
              <a
                href={siteInfo.ctaSecondary.href}
                onClick={(e) => handleClick(e, siteInfo.ctaSecondary.href)}
                className="inline-flex items-center gap-2 px-6 py-3 bg-background-100 text-foreground-800 rounded-full text-sm font-medium hover:bg-background-200 transition-colors duration-200 whitespace-nowrap cursor-pointer border border-background-300/60"
              >
                <i className="ri-download-2-line"></i>
                {siteInfo.ctaSecondary.label}
              </a>
            </div>
          </div>

          <div className="w-full lg:w-1/2 flex justify-center">
            <div className="w-full max-w-[500px]">
              <img
                src="https://readdy.ai/api/search-image?query=A%20beautiful%20artistic%20illustration%20of%20a%20young%20person%20reading%20manga%20on%20a%20digital%20tablet%20surrounded%20by%20floating%20cherry%20blossom%20petals%2C%20warm%20pink%20and%20cream%20color%20palette%2C%20soft%20dreamy%20atmosphere%2C%20manga%20style%20art%2C%20clean%20minimal%20background%20with%20subtle%20gradient%2C%20modern%20digital%20illustration%20with%20gentle%20lighting%2C%20cozy%20reading%20vibe&width=800&height=700&seq=hero-manga-visual&orientation=portrait"
                alt="樱花漫画 - 下拉式阅读体验"
                className="w-full h-auto rounded-2xl"
                onError={(e) => {
                  (e.target as HTMLElement).parentElement!.style.display = 'none';
                }}
              />
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}